import rsc from "@Config/resources"

export const values = [
  {
    name: "Id",
    value: "",
    filterType: "singleValue",
    resourceId: rsc.CmFilterCmId,
  },
]